// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"az_ebd","ratingsText":"az_fbd","--smallText":"az_gbd","reviewCount":"az_hbd","ratingsAndReviewsContainer":"az_ibd"};